export const FETCH_ORDER_BY_ORDER_NUMBER = "FETCH_ORDER_BY_ORDER_NUMBER";
export const FETCH_ORDER_BY_ORDER_NUMBER_FAILURE =
  "FETCH_ORDER_BY_ORDER_NUMBER_FAILURE";
export const FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS =
  "FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS";
export const RESET_TRACKED_ORDER = "RESET_TRACKED_ORDER";